(function() {
	'use strict';

	var
		os = avastGlobals.detect.os,
		html = document.querySelector('html'),
		exitPopupModal = document.querySelector('#exit-popup'),
		exitPopup = new BSN.Modal(exitPopupModal),
		
		mouseEvent = function(e) {
			var currentPlatformHash = html.classList.contains('js-ios') || html.classList.contains('js-android');

			if (!e.toElement && !e.relatedTarget && e.clientY < 10 && !currentPlatformHash) {
				document.removeEventListener('mouseout', mouseEvent);

				exitPopup.show();
			}
		};
	
	if (exitPopup && !(os.isIOS || os.isAndroid)) {
		document.addEventListener('mouseout', mouseEvent);
	}
})();